import { useEffect, useState } from 'react';
import { publishApi, sellersApi, type PublishLogEntry, type PublishLogDetail, type SellerListItem } from '../lib/api';
import { useAuth } from '../lib/auth';

export default function PublishLog() {
  const { user } = useAuth();
  const [sellers, setSellers] = useState<SellerListItem[]>([]);
  const [filterSeller, setFilterSeller] = useState<number | ''>('');
  const [entries, setEntries] = useState<PublishLogEntry[] | null>(null);
  const [detail, setDetail] = useState<PublishLogDetail | null>(null);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    if (user?.role === 'admin') sellersApi.list().then((r) => setSellers(r.sellers)).catch(() => { /* noop */ });
  }, [user]);

  useEffect(() => {
    publishApi.log({ seller_id: filterSeller || undefined, limit: 200 })
      .then((r) => setEntries(r.entries))
      .catch((e) => setErr(String(e?.message ?? e)));
  }, [filterSeller]);

  function sellerLabel(id: number | null) {
    if (id == null) return '—';
    const s = sellers.find((x) => x.id === id);
    return s ? (s.display_name || s.login) : `#${id}`;
  }

  function statusBadge(s: number | null) {
    if (s == null) return <span className="badge warn">—</span>;
    if (s >= 200 && s < 300) return <span className="badge ok">{s}</span>;
    return <span className="badge warn">{s}</span>;
  }

  return (
    <div className="container">
      <div className="page-head">
        <h2>Лог публикаций в Flowwow</h2>
      </div>

      {user?.role === 'admin' && (
        <div className="row" style={{ marginBottom: 14 }}>
          <label className="muted">Продавец:</label>
          <select value={filterSeller} onChange={(e) => setFilterSeller(e.target.value ? Number(e.target.value) : '')}>
            <option value="">Все</option>
            {sellers.map((s) => <option key={s.id} value={s.id}>{s.display_name || s.login}</option>)}
          </select>
        </div>
      )}

      {err && <div className="error">{err}</div>}
      {!entries ? <p className="muted">Загрузка…</p>
        : entries.length === 0 ? <p className="muted">Лог пуст. Ничего ещё не публиковали.</p>
        : (
          <table className="grid compact">
            <thead>
              <tr>
                <th>#</th>
                <th>Время</th>
                {user?.role === 'admin' && <th>Продавец</th>}
                <th>Товар</th>
                <th>Действие</th>
                <th>Статус</th>
                <th>Длит.</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {entries.map((e) => (
                <tr key={e.id}>
                  <td>{e.id}</td>
                  <td>{e.pushed_at?.slice(0, 19)}</td>
                  {user?.role === 'admin' && <td>{sellerLabel(e.seller_id)}</td>}
                  <td>{e.product_id ?? <span className="muted">bulk</span>}</td>
                  <td><code>{e.action}</code></td>
                  <td>{statusBadge(e.response_status)}</td>
                  <td>{e.duration_ms != null ? `${e.duration_ms}ms` : '—'}</td>
                  <td>
                    <button className="link-btn" onClick={() => publishApi.logEntry(e.id).then((r) => setDetail(r.entry))}>
                      Открыть
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}

      {detail && (
        <div className="card sub" style={{ marginTop: 20 }}>
          <div className="page-head">
            <h3>Запись #{detail.id}</h3>
            <button className="btn" onClick={() => setDetail(null)}>Закрыть</button>
          </div>
          <div className="kv">
            <span>Время:</span>       <span>{detail.pushed_at}</span>
            <span>Действие:</span>    <span><code>{detail.action}</code></span>
            <span>Продавец:</span>    <span>{sellerLabel(detail.seller_id)}</span>
            <span>Товар:</span>       <span>{detail.product_id ?? 'bulk'}</span>
            <span>HTTP статус:</span> <span>{statusBadge(detail.response_status)}</span>
            <span>Длительность:</span> <span>{detail.duration_ms} ms</span>
          </div>

          <h4 style={{ marginTop: 14 }}>Request</h4>
          <pre className="raw">{JSON.stringify(detail.request_body, null, 2)}</pre>

          <h4>Response</h4>
          <pre className="raw">{typeof detail.response_body === 'string' ? detail.response_body : JSON.stringify(detail.response_body, null, 2)}</pre>
        </div>
      )}
    </div>
  );
}
